import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export const PaymentSuccessPage: React.FC = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const paymentId = searchParams.get('payment_id');
    const collectionId = searchParams.get('collection_id');
    const externalReference = searchParams.get('external_reference');
    const status = searchParams.get('status');

    console.log('💚 Pago exitoso - Parámetros recibidos:', {
      paymentId,
      collectionId,
      externalReference,
      status
    });
  }, [searchParams]);

  const paymentId = searchParams.get('payment_id');
  const externalReference = searchParams.get('external_reference');

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-100 dark:bg-gray-950 px-4">
      <div className="max-w-md w-full bg-white dark:bg-gray-800 rounded-lg shadow-lg p-8 text-center">
        <div className="mb-6">
          <div className="mx-auto flex items-center justify-center h-20 w-20 rounded-full bg-green-100 dark:bg-green-900">
            <svg
              className="h-12 w-12 text-green-600 dark:text-green-400"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M5 13l4 4L19 7"
              />
            </svg>
          </div>
        </div>

        <h1 className="text-2xl font-bold text-slate-900 dark:text-white mb-4">
          {t('pages.payment.successTitle')}
        </h1>

        <p className="text-gray-600 dark:text-gray-400 mb-6">
          {t('pages.payment.successMessage')}
        </p>

        {paymentId && (
          <div className="bg-slate-50 dark:bg-gray-900/50 rounded-lg p-4 mb-6 text-left">
            <p className="text-sm text-gray-600 dark:text-gray-400 mb-2">
              <span className="font-semibold">ID de Pago:</span> {paymentId}
            </p>
            {externalReference && (
              <p className="text-sm text-gray-600 dark:text-gray-400">
                <span className="font-semibold">Referencia:</span> {externalReference}
              </p>
            )}
          </div>
        )}

        <button
          onClick={() => window.close()}
          className="w-full bg-teal-600 hover:bg-teal-700 text-white font-medium py-2 px-4 rounded-lg transition-colors"
        >
          {t('pages.payment.goBack')}
        </button>
      </div>
    </div>
  );
};
